/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type teamHeader_team$ref: FragmentReference;
declare export opaque type teamHeader_team$fragmentType: teamHeader_team$ref;
export type teamHeader_team = {|
  +id: string,
  +name: string,
  +canUpdate: ?boolean,
  +account: ?{|
    +rowId: any
  |},
  +$refType: teamHeader_team$ref,
|};
export type teamHeader_team$data = teamHeader_team;
export type teamHeader_team$key = {
  +$data?: teamHeader_team$data,
  +$fragmentRefs: teamHeader_team$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "teamHeader_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team"
};
// prettier-ignore
(node/*: any*/).hash = 'bf22f8ed1bcb70c1b6d0993e7b41d4e1';

module.exports = node;
